import React, { useEffect, useRef, useState } from "react";
import Isotope from "isotope-layout";
import AOS from "aos";

const Portfolio = () => {
  const isotope = useRef();
  const [filterKey, setFilterKey] = useState("*");

  useEffect(() => {
    AOS.init({ duration: 800, once: true });

    // Initialize Isotope after images load
    const loadIsotope = () => {
      isotope.current = new Isotope(".portfolio-container", {
        itemSelector: ".portfolio-item",
        layoutMode: "fitRows",
      });
    };

    const imagesLoaded = document.querySelectorAll(".portfolio-item img");
    let loaded = 0;
    imagesLoaded.forEach((img) => {
      img.onload = () => {
        loaded++;
        if (loaded === imagesLoaded.length) loadIsotope();
      };
    });

    return () => isotope.current && isotope.current.destroy();
  }, []);

  useEffect(() => {
    if (isotope.current) {
      filterKey === "*"
        ? isotope.current.arrange({ filter: "*" })
        : isotope.current.arrange({ filter: `.${filterKey}` });
    }
  }, [filterKey]);

  return (
    <section id="portfolio" className="portfolio section">
      <div className="container section-title" data-aos="fade-up">
        <h2>Portfolio</h2>
        <p>Necessitatibus eius consequatur ex aliquid fuga eum quidem sint consectetur velit</p>
      </div>

      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <ul className="portfolio-filters isotope-filters" data-aos="fade-up" data-aos-delay="200">
          {[
            { key: "*", label: "All Projects" },
            { key: "filter-web", label: "Web Design" },
            { key: "filter-mobile", label: "Mobile Apps" },
            { key: "filter-branding", label: "Branding" },
            { key: "filter-ui", label: "UI/UX" },
          ].map((filter) => (
            <li
              key={filter.key}
              onClick={() => setFilterKey(filter.key)}
              className={filterKey === filter.key ? "filter-active" : ""}
              style={{ cursor: "pointer" }}
            >
              {filter.label}
            </li>
          ))}
        </ul>

        <div className="row gy-4 portfolio-container">
          {/* Example portfolio items */}
          <div className="col-lg-4 col-md-6 portfolio-item filter-web">
            <div className="portfolio-wrapper">
              <div className="portfolio-image">
                <img src="/assets/img/portfolio/portfolio-7.webp" alt="Creative Web Project" className="img-fluid" />
              </div>
              <div className="portfolio-content">
                <h3>Digital Innovation Platform</h3>
                <p>React + Node.js + AWS</p>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 portfolio-item filter-mobile">
            <div className="portfolio-wrapper">
              <div className="portfolio-image">
                <img src="/assets/img/portfolio/portfolio-8.webp" alt="Mobile App Project" className="img-fluid" />
              </div>
              <div className="portfolio-content">
                <h3>Smart Productivity App</h3>
                <p>Flutter + Firebase + AI</p>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 portfolio-item filter-branding">
            <div className="portfolio-wrapper">
              <div className="portfolio-image">
                <img src="/assets/img/portfolio/portfolio-9.webp" alt="Branding Project" className="img-fluid" />
              </div>
              <div className="portfolio-content">
                <h3>Modern Brand Identity</h3>
                <p>Illustrator + Figma + Brand</p>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 portfolio-item filter-ui">
            <div className="portfolio-wrapper">
              <div className="portfolio-image">
                <img src="/assets/img/portfolio/portfolio-10.webp" alt="UI/UX Project" className="img-fluid" />
              </div>
              <div className="portfolio-content">
                <h3>SaaS Dashboard Design</h3>
                <p>Figma + UX + Prototyping</p>
              </div>
            </div>
          </div>
        </div>

       <div class="portfolio-cta text-center" data-aos="fade-up" data-aos-delay="400">
          <h4>Ready to start your next project?</h4>
          <p>Let's work together to bring your digital vision to life</p>
          <div class="cta-buttons">
            <a href="#contact" class="btn btn-primary">Start a Project</a>
            <a href="#portfolio" class="btn btn-outline">View All Work</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
